export default __webpack_public_path__ + "static/media/xx99-mark-i.2f74e1b5.png";